module.exports = __webpack_public_path__ + "images/般蓝pr长图06-5_02.jpg?v=6ab10f48";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/zhongduan3/般蓝pr长图06-5_02.jpg
 ** module id = 177
 ** module chunks = 1 2
 **/